export default "__VITE_ASSET__W5fB556m__"